<!-- TOYOTA Preferred Dealer -->
@if (toyota) {
  <div>
    <div class="lg:text-lg font-semibold lg:text-right mt-4 lg:mt-2 text-black">
      Mein bevorzugter Toyota-Vertragspartner
    </div>

    @if (!preferredDealer) {
      <div class="text-white lg:text-right mt-6 font-semibold bg-toyotaRed p-1">
        <span>Sie haben aktuell keinen bevorzugten Toyota-Vertragspartner.</span>
      </div>
    } @else {
      <div
        class="flex flex-row items-center mt-2 justify-between
        lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300"
      >
        <div
          class="flex items-center gap-2 cursor-pointer order-last lg:order-first"
          (click)="handleEditToyota()"
        >
          <img
            src="assets/icons/change.png"
            class="w-[24px] h-[24px] lg:w-[28px] lg:h-[28px]"
          >
          <span class="underline">{{ editPreferredDealerMode ? 'Ändern abbrechen' : 'Ändern' }}</span>
        </div>

        <div class="flex flex-col lg:text-right font-light text-lightText order-first lg:order-last">
          <div class="text-xl lg:text-2xl">{{ preferredDealer.name }}</div>
          <div>{{ preferredDealer.street }}</div>
          <div>{{ preferredDealer.postcode }} {{ preferredDealer.city }}</div>
        </div>
      </div>
    }
  </div>
}

<!-- LEXUS Preferred Dealer -->
@if (lexus) {
  <div>
    <div class="lg:text-lg font-semibold lg:text-right mt-4 lg:mt-2 text-black">
      Mein bevorzugter Lexus-Vertragspartner
    </div>

    @if (!preferredDealerLexus) {
      <div class="text-white lg:text-right mt-6 font-semibold bg-toyotaRed p-1">
        <span>Sie haben aktuell keinen bevorzugten Lexus-Vertragspartner.</span>
      </div>
    } @else {
      <div
        class="flex flex-row items-center mt-2 justify-between
        lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300"
      >
        <div
          class="flex items-center gap-2 cursor-pointer order-last lg:order-first"
          (click)="handleEditLexus()"
        >
          <img
            src="assets/icons/change.png"
            class="w-[24px] h-[24px] lg:w-[28px] lg:h-[28px]"
          >
          <span class="underline">{{ editPreferredDealerLexusMode ? 'Ändern abbrechen' : 'Ändern' }}</span>
        </div>

        <div class="flex flex-col lg:text-right font-light text-lightText order-first lg:order-last">
          <div class="text-xl lg:text-2xl">{{ preferredDealerLexus.name }}</div>
          <div>{{ preferredDealerLexus.street }}</div>
          <div>{{ preferredDealerLexus.postcode }} {{ preferredDealerLexus.city }}</div>
        </div>
      </div>
    }
  </div>
}
